import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { api } from '@/api';
import { useIsDDFeatureFlagEnabled } from '@/core/data-dog';

export function useInitializePreferences() {
  const queryClient = useQueryClient();
  const isPreferencesEnabled = useIsDDFeatureFlagEnabled('FCT_USER_PREFERENCES');

  const { isError, isIdle, isSuccess, mutate } =
    api.fct.userPreference.mutation.useInitUserPreferences(queryClient);

  useEffect(() => {
    if (isPreferencesEnabled && isIdle) {
      mutate();
    }
  }, [isPreferencesEnabled, isIdle, mutate]);

  return { isLoading: isPreferencesEnabled && !isSuccess && !isError };
}
